export default "__VITE_ASSET__ClJYpwbg__"